import React from 'react'

import ToastService from 'services/toast.service'

import PhatButton from 'components/formElements/PhatButton'

import { ExporterProps } from 'components/deckPage/modals/Export/types'

import { download } from 'utils/downloadHelper'
import { generateMTGODekFile } from './helper'

import genericStyles from 'components/deckPage/modals/Export/generic.module.scss'

export const fileGenerator = generateMTGODekFile

const MTGOFile = ({ selectedCards, categoryMap, fileName = 'archidekt_export', onSubmit }: ExporterProps) => {
  const fileContents = generateMTGODekFile(selectedCards, categoryMap)

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(fileContents)

      ToastService.create('Copied to clipboard', 'Deck Export', 'success')
    } catch {
      ToastService.create('Unable to copy to clipboard', 'Deck Export')
    }
  }

  const handleDownload = () => {
    try {
      const cleanedFileName = `${fileName.toLowerCase().replace(' ', '_')}.dek`

      download(cleanedFileName, fileContents)
    } catch {
      ToastService.create('Unable to download file', 'Deck export', 'error')
    }
  }
  return (
    <div>
      <p className={genericStyles.warning}>
        Some cards do not have MTGO IDs. These cards will export without a specific version ID. Doing so will cause MTGO
        to potentially use a different edition of the card. Occasionally MTGO will not have a card at all, when this
        happens, the import will be skipped entirely.
      </p>

      <div className={genericStyles.controls}>
        {!onSubmit && (
          <PhatButton icon="copy outline" onClick={handleCopy} color="blue">
            Copy
          </PhatButton>
        )}

        <PhatButton icon="download" color="green" onClick={() => (!onSubmit ? handleDownload() : onSubmit())}>
          Download
        </PhatButton>
      </div>
    </div>
  )
}

export default MTGOFile
